import { render, staticRenderFns } from "./FinanceTabPromotions.vue?vue&type=template&id=6bd813e3&scoped=true"
import script from "./FinanceTabPromotions.vue?vue&type=script&lang=js"
export * from "./FinanceTabPromotions.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabPromotions.vue?vue&type=style&index=0&id=6bd813e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd813e3",
  null
  
)

export default component.exports